import { useState } from 'react';
import {
  Box,
  Button,
  Input,
  Heading,
  useToast,
  Text,
  Link,
  Spinner,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import apiClient from '../api/apiClient';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleSubmit = async () => {
    if (!email) return;
    setLoading(true);

    try {
      await apiClient.post('/auth/forgot-password', { email });
      toast({
        title: 'Reset email sent.',
        description: 'Please check your inbox.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
      setEmail(''); // clear input
    } catch (err) {
      toast({
        title: 'Error',
        description: err?.response?.data?.error || 'Something went wrong.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxW="md" mx="auto" mt={10} p={6} borderWidth={1} borderRadius="lg">
      <Heading size="md" mb={4}>Forgot Password</Heading>
      <Input
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        mb={4}
        isDisabled={loading}
      />
      <Button
        colorScheme="blue"
        width="100%"
        mb={4}
        onClick={handleSubmit}
        isDisabled={!email || loading}
      >
        {loading ? (
          <>
            <Spinner size="sm" mr={2} />
            Sending...
          </>
        ) : (
          'Send Reset Link'
        )}
      </Button>
      <Text textAlign="center" mt={2}>
        Remember your password?{' '}
        <Link as={RouterLink} to="/login" color="blue.500">
          Go back to Login
        </Link>
      </Text>
    </Box>
  );
}
